import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonData } from '../interfaces/common-data';
import { Observable } from 'rxjs';
import {environment} from "../../../environments/environment.prod";

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  constructor(private http: HttpClient) { }

	getCommonData(): Observable<CommonData> {
		return this.http.get<CommonData>(environment.serverUrl + 'auth/common_data');
	}

	logout(): Observable<undefined> {
		return this.http.get<undefined>(environment.serverUrl + 'auth/logout');
	}

}
